<template>
    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">

            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder">
                    <slot name="label" class="lbltxt">
                        <span class="lbltxt" style="margin-left: 11px">
                            VENDOR BUSINESS NAME
                        </span>
                        <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                            version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                            v-b-tooltip.hover.v-dark.right.html="' This should be the media supplier name that we are placing the order with. Ie: website name, publication or station call letters'
                                ">
                            <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path
                                    d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                    id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                            </g>
                        </svg>
                    </slot>
                    <b-form-input @blur="SetDirty('VendorBusinessName')" @focus="ResetDirty('VendorBusinessName')"
                        autocomplete="off" id="BusinessName" class="omniipclass" :maxlength="20"
                        v-model="MediaVendor.VendorBusinessName" placeholder="Enter Vendor Business Name"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.VendorBusinessName.$dirty && !$v.MediaVendor.VendorBusinessName.required">
                        Required field
                    </div>
                </div>

                <div class="fieldborder row mt-2">
                    <div class="col-md-6">
                        <div>
                            <label>IDENTIFICATION NUMBER</label>
                            <OmniSelect placeholder="Select Identification Code" name="Media" :showLabel="false"
                                :options="Identificationnumberslist" label="IDENTIFICATION NUMBER" @input="IDNumberchange"
                                v-model="MediaVendor.IdentificationType" />
                        </div>

                    </div>
                    <div class="col-md-6" v-show="MediaVendor.IdentificationType">
                        <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', '##-########']"
                            style="margin-top:1.5rem;" class="form-control" v-if="IsUSTaxIDSelected"
                            @focus="ResetDirty(MediaVendor.IdentificationType)"
                            @blur="SetDirty(MediaVendor.IdentificationType)" autocomplete="off" id="usTaxId"
                            v-model="MediaVendor[MediaVendor.IdentificationType]"
                            :placeholder="'Enter US Tax ID'"></the-mask>
                        <!-- <b-form-input style="margin-top:1.5rem;" v-if="IsUSTaxIDSelected" @focus="ResetDirty(MediaVendor.IdentificationType)" @blur="SetDirty(MediaVendor.IdentificationType)" autocomplete="off" id="cilentcode" class="omniipclass" :maxlength="GetMaxLength(MediaVendor.IdentificationType)" v-model="MediaVendor[MediaVendor.IdentificationType]" v-numericOnly :placeholder="'Enter '+MediaVendor.IdentificationType"></b-form-input> -->
                        <!-- <b-form-input style="margin-top:1.5rem;" v-else-if="IsSocialSecurityNumberSelected" @focus="ResetDirty(MediaVendor.IdentificationType)" @blur="SetDirty(MediaVendor.IdentificationType)" autocomplete="off" id="cilentcode" class="omniipclass" :maxlength="GetMaxLength(MediaVendor.IdentificationType)" v-model="MediaVendor[MediaVendor.IdentificationType]" v-numericOnly :placeholder="'Enter '+MediaVendor.IdentificationType"></b-form-input> -->
                        <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['###', '###-##', '###-##-####']"
                            v-else-if="IsSocialSecurityNumberSelected" style="margin-top:1.5rem;" class="form-control"
                            @focus="ResetDirty(MediaVendor.IdentificationType)"
                            @blur="SetDirty(MediaVendor.IdentificationType)" autocomplete="off" id="socialsecurity"
                            :maxlength="11" v-model="MediaVendor[MediaVendor.IdentificationType]"
                            :placeholder="'Enter Social Security Number'"></the-mask>

                        <b-form-input style="margin-top:1.5rem;" v-else @focus="ResetDirty(MediaVendor.IdentificationType)"
                            @blur="SetDirty(MediaVendor.IdentificationType)" autocomplete="off" id="Foreign"
                            class="omniipclass" v-model="MediaVendor[MediaVendor.IdentificationType]"
                            :placeholder="'Enter ' + MediaVendor.IdentificationType"></b-form-input>

                        <div class="error-message-format"
                            v-if="MediaVendor.IdentificationType && $v.MediaVendor[MediaVendor.IdentificationType].$dirty">
                            <span v-show="!$v.MediaVendor[MediaVendor.IdentificationType].required">
                                Required field
                            </span>
                        </div>
                    </div>
                </div>

            </div>
            <div class="mt-2 d-block customdropzonearea row col-lg-8 mx-auto" v-show="MediaVendor.IdentificationType">
                <label for="axlocatoin" class="lbltxt">{{ AttachmentLabel }}</label>
                <span>
                    <svg style="margin-bottom: 1px; margin-left: 5px" width="9px" height="9px" viewBox="0 0 9 9"
                        version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        v-b-tooltip.hover.v-dark.right.html="' Attachment of a completed W-9 form or Foreign W-8 form signed and dated within the last year, required for any change in ownership'
                            ">
                        <g id="LATEST" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <path
                                d="M4.5,0 C2.014875,0 0,2.014875 0,4.5 C0,6.985125 2.014875,9 4.5,9 C6.985125,9 9,6.985125 9,4.5 C8.997375,2.016 6.984,0.002625 4.5,0 Z M4.59375,1.875 C4.90425,1.875 5.15625,2.127 5.15625,2.4375 C5.15625,2.748 4.90425,3 4.59375,3 C4.28325,3 4.03125,2.748 4.03125,2.4375 C4.03125,2.127 4.28325,1.875 4.59375,1.875 Z M5.4375,6.9375 L3.9375,6.9375 C3.7305,6.9375 3.5625,6.7695 3.5625,6.5625 C3.5625,6.3555 3.7305,6.1875 3.9375,6.1875 L4.21875,6.1875 C4.2705,6.1875 4.3125,6.1455 4.3125,6.09375 L4.3125,4.40625 C4.3125,4.3545 4.2705,4.3125 4.21875,4.3125 L3.9375,4.3125 C3.7305,4.3125 3.5625,4.1445 3.5625,3.9375 C3.5625,3.7305 3.7305,3.5625 3.9375,3.5625 L4.3125,3.5625 C4.726875,3.5625 5.0625,3.898125 5.0625,4.3125 L5.0625,6.09375 C5.0625,6.1455 5.1045,6.1875 5.15625,6.1875 L5.4375,6.1875 C5.6445,6.1875 5.8125,6.3555 5.8125,6.5625 C5.8125,6.7695 5.6445,6.9375 5.4375,6.9375 Z"
                                id="info" fill="#00A1D2" fill-rule="nonzero"></path>
                        </g>
                    </svg>
                </span>
                <vue-dropzone v-on:vdropzone-mounted="mountedIdentitificationDropzone" :duplicateCheck="true"
                    ref="identificationDropzone" id="identificationDropzone" :useCustomSlot="true" class="customdropzone"
                    :include-styling="false" :options="dropzoneOptions"
                    v-on:vdropzone-file-added="IdentificationUploadedToDropzone"
                    v-on:vdropzone-removed-file="IdentificationRemovedFromDropzone">
                    <div class="dropzone-custom-content">
                        <p class="Drag-and-drop-file-h">
                            <b-img style="
                        margin-top: -7px !important;
                        font-family: 'Open Sans';
                      " />
                            Drag and drop file here or
                            <span class="draganddropspan"> browse </span>

                        </p>
                    </div>
                </vue-dropzone>
                <div class="note-section mt-2">
                    <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
                </div>
            </div>
            <div class="d-block row col-lg-8 mx-auto mt-3">
                <b-form-group label="Did the vendor provide a link to their website?">
                    <b-form-radio-group id="url-specified" v-model="MediaVendor.IsVendorWebsiteProvided" name="IsVendorWebsiteProvided">
                        <b-form-radio value="true">Yes</b-form-radio>
                        <b-form-radio value="false">No</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </div>
            <div class="d-block row col-lg-8 mx-auto mt-n2" v-if="MediaVendor.IsVendorWebsiteProvided == 'true'">
                <label>Vendor Website Link</label>
                <b-form-input @focus="ResetDirty('VendorWebsiteLink')" @blur="SetDirty('VendorWebsiteLink')"
                    autocomplete="off" id="VendorWebsiteLink" class="omniipclass"
                    v-model="MediaVendor.VendorWebsiteLink" placeholder="Enter Website Link"></b-form-input>
            </div>
            <div class="mt-2 d-block customdropzonearea row col-lg-8 mx-auto mt-n2" v-if="MediaVendor.IsVendorWebsiteProvided == 'false'">
                <label for="axlocatoin" class="lbltxt">Attach Media Kit File</label>
                <vue-dropzone v-on:vdropzone-mounted="mountedMediaKitDropzone" :duplicateCheck="true"
                    ref="mediaKitDropzone" id="mediaKitDropzone" :useCustomSlot="true" class="customdropzone"
                    :include-styling="false" :options="dropzoneOptions"
                    v-on:vdropzone-file-added="MediaKitUploadedToDropzone"
                    v-on:vdropzone-removed-file="MediaKitRemovedFromDropzone">
                    <div class="dropzone-custom-content">
                        <p class="Drag-and-drop-file-h">
                            <b-img style="
                        margin-top: -7px !important;
                        font-family: 'Open Sans';
                      " />
                            Drag and drop file here or
                            <span class="draganddropspan"> browse </span>

                        </p>
                    </div>
                </vue-dropzone>
                <div class="note-section mt-2">
                    <p>Acceptable file types: {{ AllowedFileUploadTypes }}.</p>
                </div>
            </div>
            <div class="col-md-8 mx-auto">
                <div class="fieldborder pt-2">
                    <label>VENDOR REMITTANCE NAME</label>
                    <b-form-input @focus="ResetDirty('VendorRemittanceName')" @blur="SetDirty('VendorRemittanceName')"
                        autocomplete="off" id="VendorRemittanceName" class="omniipclass"
                        v-model="MediaVendor.VendorRemittanceName" placeholder="Enter Vendor Remittance Name"
                        :maxlength="`${IsPrintDigitalMedia ? 30 : 20}`"></b-form-input>
                </div>
                <div class="fieldborder pt-2">
                    <label>COUNTRY</label>
                    <OmniSelect class="pt-0 omniipclass omniindexclass" placeholder="Select Country"
                        name="RemittanceCountry" :showLabel="false" v-model="MediaVendor.RemittanceCountry" :options="CountryList">
                    </OmniSelect>
                </div>
                <div class="fieldborder pt-2">
                    <label>STREET ADDRESS LINE 1 </label>
                    <b-form-input @focus="ResetDirty('StreetAddressLine1')" @blur="SetDirty('StreetAddressLine1')"
                        autocomplete="off" id="StreetAddressLine1" class="omniipclass"
                        v-model="MediaVendor.StreetAddressLine1" placeholder="Enter Street Address Line1"
                        :maxlength="`${IsPrintDigitalMedia ? 26 : 24}`"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.StreetAddressLine1.$dirty && !$v.MediaVendor.StreetAddressLine1.required">
                        Required field
                    </div>
                </div>
                <div class="fieldborder pt-2" v-if="MediaVendor.RemittanceCountry && !IsCountryUSA">
                    <label>STREET ADDRESS LINE 2</label>
                    <b-form-input @focus="ResetDirty('StreetAddressLine2')" @blur="SetDirty('StreetAddressLine2')"
                        autocomplete="off" id="StreetAddressLine2" class="omniipclass"
                        v-model="MediaVendor.StreetAddressLine2" placeholder="Enter Street Address Line 2"
                        :maxlength="26"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.StreetAddressLine2 && $v.MediaVendor.StreetAddressLine2.$dirty && !$v.MediaVendor.StreetAddressLine2.required">
                        Required field
                    </div>
                </div>
                <div class="fieldborder pt-2" v-if="IsCountryUSA">
                    <label for="city" class="lbltxt" v-if="IsCountryUSA">CITY</label>
                    <b-form-input @focus="ResetDirty('RemittanceCity')" @blur="SetDirty('RemittanceCity')" autocomplete="off"
                        id="billingCity" class="omniipclass" v-if="IsCountryUSA" v-model="MediaVendor.RemittanceCity"
                        placeholder="Enter City" :maxlength="19"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.RemittanceCity.$dirty && !$v.MediaVendor.RemittanceCity.required">
                        Required field
                    </div>
                </div>
                <div class="row fieldborderomniipclass pt-2" v-if="IsCountryUSA">
                    <div class="col-md-8">
                        <label v-if="IsCountryUSA" for="RemittanceState" class="lbltxt">State</label>
                        <OmniSelect  :showLabel="false" class="pt-0 omniindexclass omniindexclass" v-if="IsCountryUSA" placeholder="Select State" name="RemittanceState" :showSearch="true" v-model="MediaVendor.RemittanceState" :options="StateList">
                        </OmniSelect>
                    </div>
                    <div class="col-md-4">
                        <label v-if="IsCountryUSA" for="RemittanceZipCode" class="lbltxt">ZIP CODE</label>
                        <b-form-input autocomplete="off" id="RemittanceZipCode" class="" :minlength="5" v-if="IsCountryUSA" :maxlength="5" v-bind:class="{
                                redtextbox: (validationtextbox || !$v.MediaVendor.RemittanceZipCode.numeric) && $v.MediaVendor.RemittanceZipCode.$dirty,
                                notredtextbox: !validationtextbox && $v.MediaVendor.RemittanceZipCode.numeric,
                            }" @blur="SetDirty('RemittanceZipCode')" @focus="ResetDirty('RemittanceZipCode')"
                            @keyup="ValidateZipCode()" v-model="MediaVendor.RemittanceZipCode"
                            placeholder="Enter Zip Code"></b-form-input>
                        <div v-show="validationtextbox && $v.MediaVendor.RemittanceZipCode.$dirty" class="error-message-format">
                            Input must be 5 characters
                        </div>
                        <div v-show="!$v.MediaVendor.RemittanceZipCode.numeric && $v.MediaVendor.RemittanceZipCode.$dirty"
                            style="width:135px;" class="error-message-format">
                            This field can only contain numerical values
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-block row col-lg-8 mx-auto mt-2">
                <b-form-group>
                    <label>
                        Vendor Email
                    </label>
                    <b-form-input type="email" @focus="ResetDirty('RemittanceAdviceEmail')"
                        @blur="SetDirty('RemittanceAdviceEmail')" autocomplete="off" placeholder="Enter Vendor Email"
                        v-model="MediaVendor.RemittanceAdviceEmail" ref="email"></b-form-input>
                    <div class="error-message-format" v-if="$v.MediaVendor.RemittanceAdviceEmail.$dirty">
                        <span v-show="!$v.MediaVendor.RemittanceAdviceEmail.required">
                            Required field
                        </span>
                        <span v-show="!$v.MediaVendor.RemittanceAdviceEmail.email">
                            Please enter a valid email address (eg. test@finsys.com)
                        </span>

                    </div>
                </b-form-group>
            </div>
            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder" style="margin-top:10px">
                    <label>Who at the vendor provided this information? </label>
                    <br />
                    <label>Name </label>
                    <b-form-input @blur="SetDirty('InfoFromName')" @focus="ResetDirty('InfoFromName')" autocomplete="off"
                        id="InfoFromName" class="omniipclass" :maxlength="36" v-model="MediaVendor.InfoFromName"
                        placeholder="Name"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.InfoFromName.$dirty && !$v.MediaVendor.InfoFromName.required">
                        Required field
                    </div>

                    <label>Title </label>
                    <b-form-input @blur="SetDirty('InfoFromTitle')" @focus="ResetDirty('InfoFromTitle')" autocomplete="off"
                        id="InfoFromTitle" class="omniipclass" :maxlength="36" v-model="MediaVendor.InfoFromTitle"
                        placeholder="Title"></b-form-input>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.InfoFromTitle.$dirty && !$v.MediaVendor.InfoFromTitle.required">
                        Required field
                    </div>

                    <label>Phone Number </label>
                    <the-mask type="text" :tokens="{ '#': { pattern: /\d/ } }" :mask="['##', FormatPhoneNumber]"
                        style="margin-top:1px;" class="form-control" @blur="SetDirty(MediaVendor.InfoFromPhone)"
                        @focus="ResetDirty(MediaVendor.InfoFromPhone)" autocomplete="off" id="InfoFromPhone" :maxlength="24"
                        v-model="MediaVendor.InfoFromPhone" placeholder="Phone Number"></the-mask>
                    <div class="error-message-format"
                        v-if="$v.MediaVendor.InfoFromPhone.$dirty && !$v.MediaVendor.InfoFromPhone.required">
                        Required field
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button v-if="IsDraftVisible" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
                SAVE FOR LATER
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Previous()">
                BACK
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()"
                :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>

    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapGetters } from "vuex";
import { TheMask } from 'vue-the-mask'
import { required, requiredIf, numeric, minLength, maxLength, helpers } from "vuelidate/lib/validators";
import service from "../../../services/Dropdowns";
import store from "@/store";
import * as AllowedFileUploadExtensions from "../../../utilities/AllowedFileUploadExtensions";
const EmailRegEx = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[x01-x08x0bx0cx0e-x1fx21x23-x5bx5d-x7f]|[x01-x09x0bx0cx0e-x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[x01-x08x0bx0cx0e-x1fx21-x5ax53-x7f]|\\[x01-x09x0bx0cx0e-\x7f])+)\])$/
const EmailWithoutCase = helpers.regex('EmailWithoutCase', EmailRegEx)
import mediaVendorSaveAsDraft from '../../../mixins/mediaVendorSaveAsDraft';
export default {
    mixins: [mediaVendorSaveAsDraft],
    components: {
        vueDropzone: vue2Dropzone,
        TheMask
    },
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            IsIdentificationFilesLoadedInEdit: false,
            IsMediaKitFilesLoadedInEdit: false,
            Identificationnumberslist: [{
                label: "US TAX ID",
                value: "USTaxID"
            },
            {
                label: "Foreign",
                value: "Foreign"
            },
            {
                label: "Social Security",
                value: "SocialSecurityNumber"
            },
            ],
            //MediaVendor: {
            //     VendorBusinessName: null,
            //     IdentificationCode: null,
            //     IdentificationNumber: null,
            //     UrlSpecifiedInForm: null,
            //     RemittanceAdviceEmail: null
            // },
            InvoicesImmediatePaymentOptions: [
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" }
            ],
            AllowedFileUploadTypes: AllowedFileUploadExtensions.FileUploadExtensions.join(", "),
            dropzoneOptions: {
                paramName: "file",
                //params: {'param_1':'xyz','para_2': localid },
                previewTemplate: this.template(),
                url: `${process.env.VUE_APP_API_ROOT}api/v1/mdm/Upload`,
                uploadMultiple: true,
                maxFiles: 5,
                minFiles: 1,
                maxFilesize: 10,
                addRemoveLinks: false,
                parallelUploads: 5,
                createImageThumbnails: false,
                autoProcessQueue: false,
                init: function () {
                    this.on("addedfile", function (file) {
                        if (this.files.length > 5) {
                            this.removeFile(file);
                            window.alert("Maximum File Upload limit is 5!");
                        }
                    });

                    this.on("removedfile", function () { });
                },
                accept: function(file, done) {
                    let fileExtension = file.name.split('.').pop().toLowerCase();
                    if (!AllowedFileUploadExtensions.FileUploadExtensions.includes(fileExtension)) {
                        store.dispatch(
                            "progress/setErrorMessage",
                            `Unsupported file type. Please upload a valid file type.`
                        );
                        this.removeFile(file);
                    } else {
                      done();
                    }
                },
            },
            deleteIcon: require("@/assets/Icons/delete.svg"),
            closeFilterIcon: require("../../../assets/Icons/file.png"),
            CountryList: [],
            StateList: [],
            CountryUnitedStatesValue: "USA - United States",
            validationtextbox: false,
        }
    },
    validations: {
        MediaVendor: {
            VendorBusinessName: {
                required: required,
            },
            IdentificationType: {
                required: required,
            },
            RemittanceAdviceEmail: {
                required: requiredIf(function () {
                    return this.MediaVendor.IsMediaRepRequest == "true" || this.MediaVendor.IsMediaRepRequest == true;
                }),
                email: EmailWithoutCase
            },
            USTaxID: {
                required: requiredIf(function (model) {
                    return model.IdentificationType == "USTaxID";
                }),
                numeric,
                minLength: minLength(9)
            },
            SocialSecurityNumber: {
                required: requiredIf(function (model) {
                    return model.IdentificationType == "SocialSecurityNumber";
                }),
                numeric,
                minLength: minLength(9),
                maxLength: maxLength(9),
            },
            Foreign: {
                required: requiredIf(function (model) {
                    return model.IdentificationType == "Foreign";
                })
            },
            IdentificationFiles: {
                minLength: minLength(1),
                required: requiredIf(function (model) {
                    return model.IdentificationType == "USTaxID" || model.IdentificationType == "SocialSecurityNumber" || model.IdentificationType == "Foreign";
                })
            },
            InfoFromName: { required },
            InfoFromTitle: { required },
            InfoFromPhone: {
                required,
                minLength: minLength(10)
            },
            VendorRemittanceName: {
                required: required
            },
            RemittanceCountry: {
                required: required
            },
            StreetAddressLine1: {
                required: required
            },
            RemittanceCity: {
                required: requiredIf(function (model) {
                    return model.RemittanceCountry == this.CountryUnitedStatesValue;
                }),
            },
            RemittanceState: {
                required: requiredIf(function (model) {
                    return model.RemittanceCountry == this.CountryUnitedStatesValue;
                }),
            },
            RemittanceZipCode: {
                required: requiredIf(function (model) {
                    return model.RemittanceCountry == this.CountryUnitedStatesValue;
                }),
                numeric,
            },
            IsVendorWebsiteProvided: {
                required: required
            },
            VendorWebsiteLink: {
                required: requiredIf(function () {
                    return this.MediaVendor.IsVendorWebsiteProvided == "true" || this.MediaVendor.IsVendorWebsiteProvided == true;
                }),
            },
            MediaKitAttachments: {
                minLength: minLength(1),
                required: requiredIf(function (model) {
                    return model.IsVendorWebsiteProvided == "false" || model.IsVendorWebsiteProvided == false;
                })
            },
            StreetAddressLine2: {
                required: requiredIf(function (model) {
                    return model.RemittanceCountry !== this.CountryUnitedStatesValue;
                }),
                maxLength: maxLength(26)
            },
        }
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    watch: {
        "MediaVendor.IsVendorWebsiteProvided": function(val) {
            if (val == false || val == 'false') {
                this.MediaVendor.VendorWebsiteLink = '';
            }
        },
        "MediaVendor.InfoFromPhone": function() {
            if (this.MediaVendor.InfoFromPhone.length > 10) {
                this.FormatPhoneNumber = true;
            }
            else {
                this.FormatPhoneNumber = false;
            }
        },
        "MediaVendor.MediaType": function(val) {
            if (val || !val) {
                this.MediaVendor.StreetAddressLine1 = '';
                this.MediaVendor.VendorRemittanceName = '';
            }
        },
        "MediaVendor.IsEditDataLoaded": function (val) {
            if (this.IsEdit == true && val == true) {
                if (this.IsMediaKitFilesLoadedInEdit == false) {
                    this.ManuallyUploadMediaKitFiles(this.MediaVendor.MediaKitAttachments);
                    this.$set(this.MediaVendor, "MediaKitAttachments", this.GetMediaKitFilesObject());
                }
                if (this.IsIdentificationFilesLoadedInEdit == false) {
                    this.ManuallyUploadFilesIdentification(this.MediaVendor.IdentificationFiles);
                    this.$set(this.MediaVendor, "IdentificationFiles", this.GetIDFilesObject());
                }
            }
        },
        "MediaVendor.IdentificationType": function (val) {
            if (val) {
                let identificationIndex = this.Identificationnumberslist.findIndex(newVal => {
                    return newVal.value == val;
                })
                if (identificationIndex > -1) {
                    this.$set(this.MediaVendor, "IdentificationName", this.Identificationnumberslist[identificationIndex].label);
                }
                else {
                    this.$set(this.MediaVendor, "IdentificationName", '');
                }
            }
        },
        "MediaVendor.RemittanceCountry": function (val) {
            if (val) {
                this.MediaVendor.RemittanceCity = '';
                this.MediaVendor.RemittanceState = '';
                this.MediaVendor.RemittanceZipCode = '';
                if (val === this.CountryUnitedStatesValue) {
                    this.MediaVendor.StreetAddressLine2 = '';
                }
            }
        },
    },
    computed: {
        FormatPhoneNumber() {
            const infoFromPhone = this.MediaVendor.InfoFromPhone || '';
            return infoFromPhone.length > 10 ? '####################' : '1-###-###-#####';
        },
        charLimit() {
            return this.MediaVendor.IsDigitalMedia === 'true' && this.MediaVendor.MediaType ? '20' : '20' || this.MediaVendor.IsDigitalMedia === 'true' ? '30' : '20';
        },
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        ...mapGetters('mediavendor', {
            MediaVendor: 'MediaVendor',
        }),
        IsUSTaxIDSelected() {
            return this.MediaVendor.IdentificationType == 'USTaxID';
        },
        IsSocialSecurityNumberSelected() {
            return this.MediaVendor.IdentificationType == 'SocialSecurityNumber';
        },
        AttachmentLabel() {
            return this.MediaVendor.IdentificationType == 'SocialSecurityNumber' || this.MediaVendor.IdentificationType == 'USTaxID' ? 'W-9 Attachment' : 'W-8BEN/W-8BEN-E Attachment';
        },
        IsCountryUSA() {
            return this.MediaVendor.RemittanceCountry != null ? this.MediaVendor.RemittanceCountry == this.CountryUnitedStatesValue : null;
        },
        IsPrintDigitalMedia() {
            const isDigital = this.MediaVendor.IsDigitalMedia == true || this.MediaVendor.IsDigitalMedia == 'true';
            const isMediaTypeEmpty = !this.MediaVendor.MediaType;
            return (this.MediaVendor.PrintValueSelected == this.MediaVendor.MediaType) || (isDigital && isMediaTypeEmpty);
        },
        IsDraftVisible() {
            return this.id == null || this.id == 0 || this.isDraft == true;
        },
    },
    mounted() {
        this.LoadDropdownValues();
    },
    methods: {
        IDNumberchange() {
            this.MediaVendor.USTaxID = "";
            this.MediaVendor.SocialSecurityNumber = "";
            this.MediaVendor.Foreign = "";
            this.$refs.identificationDropzone.removeAllFiles()
        },
        mountedMediaKitDropzone() {
            if (this.MediaVendor.ID > 0 || this.isDraft === true) {
                this.ManuallyUploadMediaKitFiles(this.MediaVendor.MediaKitAttachments);
                this.$set(this.MediaVendor, "MediaKitAttachments", this.GetMediaKitFilesObject());
            }
        },
        mountedIdentitificationDropzone() {
            if ((this.MediaVendor.ID > 0 && this.IsIdentificationFilesLoadedInEdit == false) || this.isDraft === true) {
                this.ManuallyUploadFilesIdentification(this.MediaVendor.IdentificationFiles);
                this.$set(this.MediaVendor, "IdentificationFiles", this.GetIDFilesObject());
            }
        },
        ManuallyUploadMediaKitFiles(files) {
            if (files != null && files.length > 0) {
                files.forEach((fileUploaded) => {
                    let file = {
                        size: fileUploaded.Length,
                        name: fileUploaded.Name,
                        type: fileUploaded.Extension,
                    };
                    var url = fileUploaded.FullName;
                    this.$refs.mediaKitDropzone.manuallyAddFile(file, url);
                });
            }
            this.IsMediaKitFilesLoadedInEdit = true;
        },
        ManuallyUploadFilesIdentification(files) {
            if (files != null && files.length > 0) {
                files.forEach((fileUploaded) => {
                    let file = {
                        size: fileUploaded.Length,
                        name: fileUploaded.Name,
                        type: fileUploaded.Extension,
                    };
                    var url = fileUploaded.FullName;
                    this.$refs.identificationDropzone.manuallyAddFile(file, url);
                });

            }
            this.IsIdentificationFilesLoadedInEdit = true;
        },
        IsNumeric(prop) {
            let props = [{
                name: 'USTaxID',
                type: 'numeric'
            }, {
                name: 'SocialSecurityNumber',
                type: 'numeric'
            }, {
                name: 'Foreign',
                type: 'text'
            }];
            let index = props.findIndex(val => val.name == prop);
            if (index > -1) {
                return props[index].type == 'numeric';
            } else {
                return false;
            }
        },
        SetDirty(propertyName) {
            this.$v.MediaVendor[propertyName].$touch();

        },
        ResetDirty(propertyName) {
            this.$v.MediaVendor[propertyName].$reset();
        },
        MediaKitUploadedToDropzone() {
            this.$set(this.MediaVendor, "MediaKitAttachments", this.GetMediaKitFilesObject());
        },
        MediaKitRemovedFromDropzone() {
            this.$set(this.MediaVendor, "MediaKitAttachments", this.GetMediaKitFilesObject());
        },
        IdentificationUploadedToDropzone() {
            this.$set(this.MediaVendor, "IdentificationFiles", this.GetIDFilesObject());
        },
        IdentificationRemovedFromDropzone() {
            this.$set(this.MediaVendor, "IdentificationFiles", this.GetIDFilesObject());
        },
        GetMediaKitFilesObject() {
            let files = [];
            if (this.$refs.mediaKitDropzone.dropzone.files && this.$refs.mediaKitDropzone.dropzone.files.length > 0) {
                let filesExists = this.$refs.mediaKitDropzone.dropzone.files;
                for (let i = 0; i < filesExists.length; i++) {
                    files.push({
                        name: filesExists[i].name,
                        file: filesExists[i]
                    });
                }
                return files;
            } else {
                return files;
            }
        },
        GetIDFilesObject() {
            let files = [];
            if (this.$refs.identificationDropzone.dropzone.files && this.$refs.identificationDropzone.dropzone.files.length > 0) {
                let filesExists = this.$refs.identificationDropzone.dropzone.files;
                for (let i = 0; i < filesExists.length; i++) {
                    files.push({
                        name: filesExists[i].name,
                        file: filesExists[i]
                    });
                }
                return files;
            } else {
                return files;
            }
        },
        GetMaxLength(field) {
            if (field == 'USTaxID') {
                return 10;
            } else if (field == 'Foreign') {
                return -1;
            } else {
                return 12;
            }
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Media Vendor Relationship Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Media Vendor Relationship Info"
                });
            }
        },
        Cancel() {
            this.$router.push("/VendorRequests");
        },
        Previous() {
            if (this.id) {
                this.$router.push({
                    name: "Media Vendor Credit Info",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Media Vendor Credit Info"
                });
            }
        },
        template: function () {
            return `<div class="dz-preview dz-file-preview" style='background-color:#ffffff !important;display:flex;'>

                <div class="dz-details" style='margin-right:79px !important;'>
                    <div class="dz-size" style="display:none;" ><span data-dz-size></span></div>
                    <div class="FileforNewClientxls-Copy" style="margin-left:20px;width:280px;cursor:default !important;" ><span style='word-break:break-all !important;font-size:14px !important;font-weight:400;font-stretch:normal;font-style: normal;line-height: 0.71;color: #00a1d2 !important; font-family:"Open Sans" !important;' data-dz-name></span></div>
                </div>
                <a>
                 <img data-dz-remove=""  style='' src='/icons/fileremove.svg'  @click="DeleteServerFile()" ></img>
                </a>
            </div>`;
        },
        LoadDropdownValues() {
            this.LoadStates();
            service
                .getEntityRecords("Markets")
                .then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.CountryList = res.data.sort((a, b) =>
                            a.label < b.label ? -1 : a.label > b.label ? 1 : 0
                        );
                        let indexUSA = this.CountryList.findIndex(
                            (i) => i.label == this.CountryUnitedStatesValue
                        );
                        let indexCanada = this.CountryList.findIndex(
                            (i) => i.label == "CAN - Canada"
                        );
                        if (indexCanada > -1)
                            this.CountryList.unshift(
                                this.CountryList.splice(indexCanada, 1)[0]
                            );
                        if (indexUSA > -1)
                            this.CountryList.unshift(this.CountryList.splice(indexUSA, 1)[0]);
                        this.CountryList.forEach(element => { element.value = element.label;});
                    }
                })
                .catch((err) => {
                    alert(err);
                });
        },
        async LoadStates() {
            service
                .getEntityRecords("States")
                .then((res) => {
                    this.StateList = res.data;
                    this.StateList.forEach(element => { element.value = element.label;});
                })
                .catch((err) => {
                    alert(err);
                });
        },
        ValidateZipCode() {
            if (this.IsCountryUSA && this.MediaVendor.RemittanceZipCode.length != 0 && this.MediaVendor.RemittanceZipCode.length < 5) {
                this.validationtextbox = true;
            } else {
                this.validationtextbox = false;
            }
        },
    }
}
</script>

<style>
fieldset.form-group:not(.custom-radio)>legend {
    padding-left: 0px !important;
}

/*file upload starts*/

.customdropzonearea .customdropzone {
    width: 411px !important;
    height: 100% !important;
    border-radius: 8px !important;
    border: dashed 2px #e9eef0 !important;
    background-color: #ffffff !important;
    cursor: pointer !important;
}

.Drag-and-drop-file-h {
    /* margin-left: 97px !important; */
    margin-top: 14px !important;
    width: 237px !important;
    height: 10px !important;
    font-family: "Open Sans" !important;
    font-size: 14px !important;
    font-weight: normal !important;
    font-stretch: normal !important;
    font-style: normal !important;
    line-height: 0.71 !important;
    letter-spacing: normal !important;
    color: #a2a9ad !important;
}

.draganddropspan {
    color: #00a1d2;
}

/*file upload ends*/
</style>
